import { GET_AUDIO_ENERGY_SUCCESS, GET_AUDIO_ENERGY_FAILURE, GET_AUDIO_ENERGY_REQUESTED } from './energy.constants'

import { GET_CONTACT_REQUESTED } from '../MediaPlayer/mediaPlayer.constants'
import { Reducer } from '@reduxjs/toolkit'
import { EnergyAction } from './energy.actions'

interface EnergyState {
  loading: boolean,
  error: boolean,
  data: $TSFIXME,
}

const initialState: EnergyState = {
  loading: true,
  error: false,
  data: null,
}

const reducer: Reducer<EnergyState, EnergyAction> = (state = initialState, action) => {
  switch (action.type) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- TODO: remove type assertion
    case GET_CONTACT_REQUESTED as $TSFIXME: // TODO: figure out how to handle this type; maybe include the action return type in EnergyAction type union
      return { ...initialState }
    case GET_AUDIO_ENERGY_REQUESTED:
      return {
        ...state,
        loading: true,
        error: false,
        data: null,
      }
    case GET_AUDIO_ENERGY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.data,
      }

    case GET_AUDIO_ENERGY_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        data: null,
      }

    default:
      return state
  }
}

export default reducer
